import { ReactElement } from 'react';
import { Location } from 'pages/locations';
import ScheduleAppointmentCta from 'components/UI/ScheduleAppointmentCta';
import Link from './Link';
import NewLocationDetailsCard from './NewLocationDetailsCard';
import { IFragmentLocationBanner } from 'types/contentful';

type LocationCardProps = {
  location: Location;
  className?: string;
  activeLocation?: Location | null;
  locationBanners: IFragmentLocationBanner[];
  factua?: boolean;
  onClick?: (slug: string) => void;
};

export default function NewLocationCard({
  location,
  className = '',
  activeLocation,
  locationBanners,
  factua = false,
}: LocationCardProps): ReactElement {
  const hasBannerText = !!(
    location?.sysId &&
    locationBanners &&
    locationBanners.some(({ fields }) => fields.locations?.includes(location.sysId || ''))
  );

  return (
    <div
      className={`flex w-full flex-col gap-4 rounded-sm border border-transparent px-5 py-4 text-left transition ease-linear duration-100 md:flex-row md:items-start md:justify-between md:gap-5 lg:px-5 ${
        activeLocation == location ? 'bg-white' : 'bg-transparent'
      } lg:hover:bg-white ${className}`}
    >
      <div className="w-full md:flex-1">
        <NewLocationDetailsCard
          showWarningIcon={hasBannerText}
          showLocationIcon={true}
          location={location}
          size={'lg'}
        />
      </div>
      <div className="w-full md:w-auto md:min-w-cta">
        <div className="flex w-full flex-col space-y-3 text-center">
          <ScheduleAppointmentCta
            location={location}
            colorScheme="Primary"
            wrapperClasses=""
            text="Schedule an Eye Exam"
            classNames="flex w-full justify-center whitespace-nowrap"
            factua={factua}
            from="location"
          />
          <Link slug={`locations/${location?.slug}`}>
            <a className="block text-primary-actual text-base mt-1 md:mt-2">
              View Location Details
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
}
